import { Color } from 'assets/theme/colors';
import styled from 'styled-components';

type Props = {
  color?: string;
};

export const FooterDiv = styled.div<Props>`
  width: 100%;
  padding: 2.58rem 0;
  p {
    color: ${({ color }) => (color ? color : '#737373')};
  }
`;
export const About = styled.div<Props>`
  color: ${({ color }) => (color ? color : Color.darkGray100)};
  overflow: hidden;
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 6; /* number of lines to show */
  line-clamp: 6;
  -webkit-box-orient: vertical;
`;

export const Inner = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  padding: 2.5rem 0;
  h4 {
    padding-bottom: 1rem;
    color: ${({ color }) => color};
  }
  @media (max-width: 640px) {
    justify-content: left;
  }
`;

export const FooterList = styled.div<Props>`
  h4 {
    padding-bottom: 1rem;
  }

  svg {
    cursor: pointer;
    transition: all 250ms ease-in-out;
    &:hover {
      transform: scale(1.2);
    }
  }
  @media (max-width: 768px) {
    flex: 0 0 22%;
  }

  @media (max-width: 640px) {
    &:first-of-type {
      flex: 0 0 100%;
    }
    flex: 0 0 30%;
    justify-content: left;
  }

  @media (max-width: 480px) {
    flex: 0 0 45%;
  }
`;

export const FooterListItems = styled.div<Props>`
  p {
    padding-bottom: 1rem;
    color: ${({ color }) => (color ? color : Color.darkGray100)};
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  gap: 30px;
`;
export const IconBox = styled.div`
  width: 30px;
`;

export const CopyRight = styled.div`
  color: ${({ color }) => (color ? color : '#737373')};
  padding: 2rem 0;
  text-align: center;
`;

export const FooterWatermark = styled.div<Props>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #e1e1e1;

  p {
    color: ${({ color }) => (color ? color : 'white')};
    padding: 2rem 0;
    text-align: center;
  }

  .brand-logo {
    display: flex;
    align-items: center;
  }
`;

export const FooterLogo = styled.div`
  .logo {
    width: 250px;
    margin-top: 1rem;
    padding-left: .5rem;
  }
`;
